import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SignatoryApiResponse, SignatoryEntry } from '../models/signatory-entry.model';
import config from '../../../../config.js';
import { base64ToBlob } from '../../../shared/utils/base64-utils';

@Injectable({ providedIn: 'root' })
export class SignatoryService {
  private readonly base = config.API_GATEWAY_ENDPOINT?.replace(/\/$/, '') || '';
  private readonly endpoint = `${this.base}/signatory_list`;

  constructor(private http: HttpClient) {}

  /**
   * Returns all active signatory entries sorted ascending by Legal Entity ID.
   * Calls GET /todo/signatory_list and maps the API response to SignatoryEntry[].
   * Null fields from the API are coerced to empty strings.
   */
  downloadPdf(): Observable<Blob> {
    return this.http
      .get(`${this.endpoint}/pdf`, { responseType: 'text' })
      .pipe(map((base64) => base64ToBlob(base64, 'application/pdf')));
  }

  triggerBlobDownload(blob: Blob, filename: string): void {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

  getSignatories(): Observable<SignatoryEntry[]> {
    return this.http.get<SignatoryApiResponse[]>(this.endpoint).pipe(
      map((entries) =>
        entries
          .map((e) => ({
            id: e.legal_entity_id,
            companyName: e.company_name ?? '',
            address: e.address ?? '',
            companyRegistrationNumber: e.company_registration_number ?? '',
          }))
          .sort((a, b) => a.id - b.id),
      ),
    );
  }
}
